<template>
<div class="h-100">
    <div class="box-page">
        <div class="page-header">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">รายการฝาก</span>
                <div id="wgCalendar" class="wgCalendar-normal ml-2" data-initLabelText="ทั้งหมด"></div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-search2">
                        <i class="fa fa-search"></i>
                        <input type="text" name="search" placeholder="ค้นหาชื่อและเบอร์โทร" v-model="keyword" @keypress.enter="loadList()" class="ele-search2-input">
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content">
            <div class="w-100" style="overflow-x: auto;">
                <table id="tb_datalist" class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width:170px;min-width: 170px">
                            </th>
                            <th style="width:70px;">
                                <div class="text-btn header-text text-center">
                                    <span>ลำดับ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>วันที่ทำรายการ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text text-center">
                                    <span>สถานะ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ชื่อ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>เบอร์โทร</span>
                                </div>
                            </th>
                            <th style="width: 180px;">
                                <div class="text-btn header-text text-right">
                                    <span>ยอดเงิน</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>สลิป</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ผู้อนุมัติ</span>
                                </div>
                            </th>
                            <th style="width: 160px;">
                                <div class="text-btn header-text">
                                    <span>วันที่อนุมัติ</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in listDeposit" :key="idx">
                            <td class="align-middle text-center">
                                <div class="show-on-hover" v-if="!item.is_completed && !item.is_cancel">
                                    <div class="btn-group">
                                        <button class="btn btn-table" @click="confirmDeposit(item)">ยืนยันการฝาก</button>
                                    </div>
                                    <div class="btn-group">
                                        <a data-toggle="dropdown" href="">
                                            <img height="24" :src="'../../goobank_assets/common/img/icons/threedots.png'" />
                                        </a>
                                        <div class="dropdown-menu">
                                            <a href="#" class="dropdown-item" @click.prevent="confirmDeposit(item, true)">ยืนยันการฝากผ่อนผัน</a>
                                            <a href="#" class="dropdown-item" @click="cancelDeposit(item.id)">ยกเลิกรายการ</a>
                                        </div>
                                    </div>
                                </div>
                                <!-- Show view detail when request completed -->
                                <div class="show-on-hover" v-else>
                                    <div class="btn-group">
                                        <button class="btn btn-table" @click="confirmDeposit(item)">รายละเอียด</button>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span v-text="getRowNo(idx + 1)"></span>
                            </td>
                            <td>
                                <span v-text="item.created_at_text"></span>
                            </td>
                            <td class="text-center">
                                <span class="tag-staff" :class="item.status_css" v-text="item.status_text"></span>
                            </td>
                            <td>
                                <span v-text="item.member_name"></span>
                            </td>
                            <td>
                                <span v-text="item.member_phone"></span>
                            </td>
                            <td class="text-right">
                                <span v-text="item.amount"></span>
                            </td>
                            <td>
                                <span v-text="item.has_slip"></span>
                            </td>
                            <td>
                                <span v-text="item.approver_name"></span>
                            </td>
                            <td>
                                <span v-text="item.approve_at_text"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <PaginationComponent :lastPage="lastPage" :currentPage="currentPage" ref="pagination"
                @prevPage="prevPage_Click()" @nextPage="nextPage_Click()" @changePage="changePage_Click($event)"></PaginationComponent>
            </div>
        </div>
    </div>

    <div class="modal-group">
        <div id="modal_confirm" class="modal fade">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <h4 class="modal-title">ยืนยันการโอน</h4>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="icon-close"></i>
                            </span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="container">
                            <div class="with-underline text-center">
                                <div v-text="confirmValue.amount" class="amount-confirm mb-3"></div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <span v-text="confirmValue.bankName || 'ธนาคาร'"></span>
                                        </div>
                                        <div class="col-md-6">
                                            <span>เลขบัญชี</span>
                                            <span v-text="confirmValue.bankAccount"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="confirmValue.slipUrl" class="row">
                                <div class="col-md">
                                    <div class="slip-container">
                                        <img :src="confirmValue.slipUrl" class="slip-img" alt="สลิปโอนเงิน">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer" v-if="!confirmValue.is_completed && !confirmValue.is_cancel">
                        <div>
                            <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ยกเลิก</button>
                            <button type="button" class="btn btn-small btn-ok" data-dismiss="modal" @click="approveDeposit">ตกลง</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal_cancel_deposit_reason" class="modal fade">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <h4 class="modal-title">ยกเลิกการฝากเพราะ...</h4>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="icon-close"></i>
                            </span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="container">
                            <div class="mb-2">เลือกเหตุผลในการยกเลิก</div>
                            <select v-model="reason" class="form-control">
                                <option>รูปภาพ หรือสลิปเงินฝากที่ลูกค้าอัพโหลดมาไม่ตรงกับที่ระบบต้องการหรือไม่ถูกต้อง</option>
                                <option>ยอดเงินที่ลูกค้าฝากมาไม่ตรงกับที่ระบบกำหนดให้โอน</option>
                            </select>
                        </div>
                    </div>

                    <input type="hidden" v-model="reason_id" />
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div>
                            <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ยกเลิก</button>
                            <button type="button" class="btn btn-small btn-ok" data-dismiss="modal" @click="confirmCancelDeposit">ยืนยันการปฏิเสธการฝาก</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
    import PaginationComponent from './../sub_components/PaginationComponent';
    export default {
        components: {
            PaginationComponent
        },
        data: function () {
            return {
                listDeposit: [],
                startDate: null,
                endDate: null,
                keyword: '',
                confirmValue: {
                    id: null,
                    amount: null,
                    bankName: '',
                    bankAccount: '',
                    isDeferredDeposit: false,
                },
                totalPage: 1,
                totalItems: 0,
                lastPage: 1,
                pageSize: 50,
                currentPage: 1,
                reason: '',
                reason_id: 0
            }
        },
        mounted() {
        },
        created() {
            this.buildJquery();
            this.loadList();
            setInterval(() => {
                this.loadList();
            }, 5000);
        },
        computed: {
        },
        methods: {
            formatDateTime(value) {
                if (!value) return '-';
                const d = new Date(value);
                if (isNaN(d.getTime())) return '-';
                const pad = n => String(n).padStart(2, '0');
                return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
            },
            prevPage_Click() {
                this.currentPage -= 1;
                this.loadList();
            },
            nextPage_Click() {
                this.currentPage += 1;
                this.loadList();
            },
            changePage_Click(pageNo) {
                this.currentPage = pageNo;
                this.loadList();
            },
            loadList() {
                let params = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    keyword: this.keyword,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage
                };
                axios.post(`${this.baseUrl}/admin/api/list-deposit`, params).then(({ data }) => {
                    if (data != null) {
                        const rows = Array.isArray(data.data) ? data.data : [];
                        if (rows.length > 0) {
                            rows.forEach(item => {
                                item.created_at_text = this.formatDateTime(item.created_at);
                                item.approve_at_text = item.approve_at ? this.formatDateTime(item.approve_at) : '-';
                                item.status_text = (item.is_completed ? 'ตรวจสอบแล้ว' : item.is_cancel ? 'ยกเลิก' : 'ยังไม่ได้ตรวจสอบ');
                                item.status_css = item.is_completed ? 'tag-complete' : 'tag-wait';
                                item.has_slip = !!item.slip ? 'มีสลิป' : 'ไม่มีสลิป';
                            });
                        }
                        this.totalItems = (parseInt(data.total, 10) || 0);
                        this.lastPage = (parseInt(data.totalPage, 10) || 1);
                        this.listDeposit = rows;

                        this.$nextTick(() => {
                            if (this.$refs.pagination && typeof this.$refs.pagination.bindListPageNo === 'function') {
                                this.$refs.pagination.bindListPageNo();
                            }
                        });
                    }
                });
            },
            choosePage(currentPage) {
                this.currentPage = currentPage;
                this.loadList();
            },
            getRowNo(index) {
                return ((this.currentPage - 1) * this.pageSize) + index;
            },
            confirmDeposit(tran, isDeferredDeposit = null) {
                this.confirmValue.id = tran.id;
                this.confirmValue.amount = tran.amount;
                this.confirmValue.bankName =  tran.bank_name;
                this.confirmValue.bankAccount =  tran.bank_account;
                this.confirmValue.slipUrl = tran.slip;
                this.confirmValue.isDeferredDeposit = isDeferredDeposit === null
                    ? !!tran.is_deferred_deposit
                    : !!isDeferredDeposit;

                this.confirmValue.is_completed = tran.is_completed
                this.confirmValue.is_cancel = tran.is_cancel
                $('#modal_confirm').modal('show');
            },
            cancelDeposit(id) {
                this.reason_id = id;
                this.reason = '';
                $('#modal_cancel_deposit_reason').modal('show');
            },
            confirmCancelDeposit()
            {
                const vm = this;
                axios.post(`${this.baseUrl}/admin/api/cancel-deposit`,{
                    id: vm.reason_id,
                    reason: vm.reason
                }).then(({ data }) => {
                    if (data != null && data.success) {
                        alertbox('บันทึกสำเร็จ');
                        this.loadList();
                    } else if (data != null && data.message) {
                        alertbox(data.message, 'warning');
                    }
                })
                .catch(err => {
                    console.log('err approve-deposit : ', err)
                });
            },
            approveDeposit() {
                axios.post(`${this.baseUrl}/admin/api/approve-deposit`,{
                    id: this.confirmValue.id,
                    is_deferred_deposit: this.confirmValue.isDeferredDeposit ? 1 : 0
                }).then(({ data }) => {
                    if (data != null && data.success) {
                        alertbox('บันทึกสำเร็จ');
                        this.loadList();
                    } else if (data != null && data.message) {
                        alertbox(data.message, 'warning');
                    }
                })
                .catch(err => {
                    console.log('err approve-deposit : ', err)
                });
            },
            buildJquery() {
                const vm = this;
                $(document).ready(function () {
                    $('#wgCalendar').wgCalendar({
                        startDate: new Date(),
                        submitDate: function(data, self) {
                            if (data.isAllDate) {
                                vm.startDate = null;
                                vm.endDate = null;
                            } else {
                                vm.startDate = moment(data.startDate).format('YYYY-MM-DD');
                                vm.endDate = moment(data.endDate).format('YYYY-MM-DD');
                            }
                            vm.loadList();
                        }
                    });
                });
            },
        },
        props: {
            baseUrl: '',
        },
    }
</script>

<style lang="scss" scoped>
    .ele-search {
        margin-left: auto;
        margin-right: 0;
        width: 400px;
        max-width: 400px;
    }
    .img-logo-bank {
        width: 24px;
        height: 24px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .tag-staff {
        width: 120px;
        display: inline-block;
        &.tag-complete {
            padding: 2px 20px;
            background-color: #01df01;
        }
        &.tag-wait {
            background-color: #ff0000;
        }
    }
    .amount-confirm {
        display: inline-block;
        padding: 8px 16px;
        border: 1px solid;
        min-width: 350px;
        font-size: 32px;
        color: #495057;
    }
    tbody td:first-of-type {
        padding: 0;
    }
    .slip-container {
        display: flex;
        margin-top: 15px;
        border: 1px solid;
    }
    .slip-img {
        max-width: 100%;
        max-height: 500px;
        margin: 0 auto;
    }
</style>








